// Centralized product image URLs for Dawaak
// Use these when populating mock product data so all product cards show real images.

export const PRODUCT_IMAGES = [
  'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
  'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
  'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
  'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
  'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
] as const

export const PRODUCT_IMAGE_1 = PRODUCT_IMAGES[0]
export const PRODUCT_IMAGE_2 = PRODUCT_IMAGES[1]
export const PRODUCT_IMAGE_3 = PRODUCT_IMAGES[2]
export const PRODUCT_IMAGE_4 = PRODUCT_IMAGES[3]
export const PRODUCT_IMAGE_5 = PRODUCT_IMAGES[4]

// Helper for cycling through images by index
export const getProductImage = (index: number): string =>
  PRODUCT_IMAGES[index % PRODUCT_IMAGES.length]
